import React from "react";

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ isVisible, title, children }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50">
      <div className="bg-slate-800 p-6 rounded-lg shadow-xl max-w-2xl w-full">
        <h3 className="text-lg font-semibold mb-4 text-white">{title}</h3>
        {children}
      </div>
    </div>
  );
};
